import { Component, Input, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/services/ux/theme.service';

@Component({
  selector: 'app-markdown-view',
  templateUrl: './markdown-view.component.html',
  styleUrls: ['./markdown-view.component.scss']
})
export class MarkdownViewComponent implements OnInit {
  private rawContent: string;

  htmlContent = "";

  constructor(public theme: ThemeService) {
  }

  ngOnInit(): void {
  }

  get content() {
    return this.rawContent;
  }

  @Input()
  set content(v: string) {
    this.rawContent = v;
    this.htmlContent = (window as any).marked(v) + "<br>";
  }
}
